/* @flow */

/* TODO: Resolve this! $FlowFixMe */
import actionTypes, { Type } from '../actions/types';
import feature from '../config/feature';

const {
  defaultSelectedPair,
  defaultSelectedAssetTab,
} = feature;

export const INITIAL_STATE = {
  selectedPair: defaultSelectedPair,
  selectedAssetTab: defaultSelectedAssetTab,
  selectedStableCoinTabs: {},
};

export const reducer = (state: Object, action: Type) => {
  switch (action.type) {
    case actionTypes.SET_SELECTED_PAIR:
      return { ...state, selectedPair: action.data };
    case actionTypes.SET_SELECTED_ASSET_TAB:
      return { ...state, selectedAssetTab: action.data };
    case actionTypes.SET_SELECTED_STABLE_COIN_TABS:
      return { ...state, selectedStableCoinTabs: action.data };
    default:
      return state;
  }
};
